import {computed} from 'mobx';

import {BaseViewModel} from "../../../infrastructure/models/base-view-model";
import {StageDomainModel} from "../../../domain/full-game/models/stage/stage-domain-model";
import {ScoreboardWidgetScoreCellViewModel} from "./scoreboard-widget.score-cell-view-model";

export class ScoreboardWidgetStageViewModel extends BaseViewModel {
  domainModel: StageDomainModel;
  isHomeCompetitorGameWinner: Boolean;
  isAwayCompetitorGameWinner: Boolean;

  constructor(domainModel: StageDomainModel, isHomeCompetitorGameWinner: Boolean = false, isAwayCompetitorGameWinner: Boolean = false) {
    super(domainModel);

    this.isHomeCompetitorGameWinner = isHomeCompetitorGameWinner;
    this.isAwayCompetitorGameWinner = isAwayCompetitorGameWinner;
  }

  get title(): String {
    return this.domainModel.shortName;
  }

  @computed get isHomeCompetitorWinner(): Boolean {
    let isHomeCompetitorWinner;

    if (this.isMainScore) {
      isHomeCompetitorWinner = this.isHomeCompetitorGameWinner;
    } else {
      const inAdvance = this.domainModel.homeCompetitorScore > this.domainModel.awayCompetitorScore || this.domainModel.homeCompetitorExtraScore > this.domainModel.awayCompetitorExtraScore;
      isHomeCompetitorWinner = inAdvance && this.domainModel.isEnded;
    }

    return isHomeCompetitorWinner;
  }

  @computed get isAwayCompetitorWinner(): Boolean {
    let isAwayCompetitorWinner;

    if (this.isMainScore) {
      isAwayCompetitorWinner = this.isAwayCompetitorGameWinner;
    } else {
      const inAdvance = this.domainModel.awayCompetitorScore > this.domainModel.homeCompetitorScore || this.domainModel.awayCompetitorExtraScore > this.domainModel.homeCompetitorExtraScore;
      isAwayCompetitorWinner = inAdvance && this.domainModel.isEnded;
    }

    return isAwayCompetitorWinner;
  }

  @computed get homeScore(): ScoreboardWidgetScoreCellViewModel {
    const homeScoreCell: ScoreboardWidgetScoreCellViewModel = new ScoreboardWidgetScoreCellViewModel(
      this.domainModel.homeCompetitorScore,
      this.domainModel.homeCompetitorExtraScore,
      this.isHomeCompetitorWinner,
      this.domainModel.isCurrent,
      this.domainModel.isLive);

    return homeScoreCell;
  }

  @computed get awayScore(): ScoreboardWidgetScoreCellViewModel {
    const awayScoreCell: ScoreboardWidgetScoreCellViewModel = new ScoreboardWidgetScoreCellViewModel(
      this.domainModel.awayCompetitorScore,
      this.domainModel.awayCompetitorExtraScore,
      this.isAwayCompetitorWinner,
      this.domainModel.isCurrent,
      this.domainModel.isLive
    );

    return awayScoreCell;
  }

  @computed get time(): String {
    return this.domainModel.time;
  }

  get isMainScore(): String {
    return this.domainModel.isCurrent;
  }

  get isLive(): String {
    return this.domainModel.isLive;
  }
}